export function isPasswordPin(passwordPin) {
  const passwordPinAux = passwordPin.replace(/_/gi, "");
  if (passwordPinAux.length === 4) {
    return true;
  }
  return false;
}